import { About } from '@/pages/public-profile/profiles/default';
import { ContactIdPhoto } from './ContactIdPhoto';

const AboutTab = ({ contactData, loading }) => {
  return (
    <div className='flex flex-col lg:flex-row gap-5 lg:gap-7.5 mb-5'>
      <ContactIdPhoto contact={contactData} loading={loading} />
      <About contactData={contactData} loading={loading} extraStyle={false} contactStyle={true} />
    </div>
  );
};

export { AboutTab }
